import MissionView from '../components/MissionView';

const Missions = () => (
  <>
    <MissionView />
  </>
);

export default Missions;
